







































































import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import HasValidation from "@/mixins/HasValidation";
import { BACKEND_DATETIME_FORMAT } from "@/data/date";

@Component
export default class SetTimeStampModal extends mixins(HasValidation) {
  @Prop({ required: true })
  public timestamp!: string;

  @Prop({ required: true })
  public min!: string;

  @Prop({ required: true })
  public max!: string;

  public datePicked: Date | null = null;
  public timePicked: Date | null = null;

  public isProcessing = false;

  public created() {
    let minDate = this.$moment();
    let timestamp = this.$moment().set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0
    });
    if (this.timestamp.length) {
      minDate = this.$moment(this.timestamp, BACKEND_DATETIME_FORMAT);
      timestamp = this.$moment(this.timestamp, BACKEND_DATETIME_FORMAT);
    } else if (this.min.length) {
      minDate = this.$moment(this.min, "DD/MM/YYYY HH:mm");
    }
    this.datePicked = minDate
      .set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
      })
      .toDate();

    this.timePicked = timestamp.toDate();
  }

  public get minDate() {
    return this.min
      ? this.$moment(this.min, "DD/MM/YYYY HH:mm")
          .subtract(1, "d")
          .add(1, "minute")
          .toDate()
      : null;
  }

  public get maxDate() {
    return this.max
      ? this.$moment(this.max, "DD/MM/YYYY HH:mm")
          .subtract(1, "minute")
          .toDate()
      : null;
  }

  public get minTime() {
    return !!this.min &&
      !!this.datePicked &&
      this.datePicked.getTime() ===
        this.$moment(this.min, "DD/MM/YYYY HH:mm")
          .set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
          })
          .toDate()
          .getTime()
      ? this.minDate
      : null;
  }

  public get maxTime() {
    return !!this.max &&
      !!this.datePicked &&
      this.datePicked.getTime() ===
        this.$moment(this.max, "DD/MM/YYYY HH:mm")
          .set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
          })
          .toDate()
          .getTime()
      ? this.maxDate
      : null;
  }

  public get pickedDateTime() {
    if (!!this.datePicked && !!this.timePicked) {
      const newDate: Date = this.datePicked;

      newDate.setHours(this.timePicked.getHours());
      newDate.setMinutes(this.timePicked.getMinutes());

      return this.$moment(newDate).format("DD/MM/YYYY HH:mm");
    }

    return null;
  }

  public validateBeforeSubmit() {
    this.isProcessing = true;
    this.validate()
      .then(result => {
        if (result) {
          this.$emit("success", this.pickedDateTime);
          return;
        }

        this.$store.dispatch("toast/show", {
          message: this.$t("_sentence.form_is_not_valid"),
          type: "is-danger"
        });
      })
      .finally(() => {
        this.isProcessing = false;
      });
  }
}
